import type { GroupType } from 'models';
import { BankLineIcon, Empty } from 'ui';
// TODO: Strange import
import { EntityList } from 'features/channels';
import { useGroupsInfiniteQuery } from '../../queries';

type P = {
  getPathToGroupDetail: (id: string) => string;
  groupId: string;
  groupType: GroupType;
};

const GroupsList = ({ getPathToGroupDetail, groupId, groupType }: P) => {
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useGroupsInfiniteQuery({
    filter: { ancestorId: groupId, groupType },
    pagination: { pageSize: 12 },
  });

  const groups = data?.pages.flat().flatMap((groupsPaginated) => groupsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no groups to display here',
            title: 'No groups',
          }}
          image={<BankLineIcon />}
        />
      }
      entities={groups?.map((group) => ({
        data: group,
        type: 'Group',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToGroupDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isLoading}
    />
  );
};

export default GroupsList;
